import { useState } from "react";
import { useHistory } from "react-router-dom";
import { showPCMembershipNeededModal, showPlanUpgradeNeededModal } from "../modal/index";
import USER_PRIVILEGES, { MembershipType, SlidFeatures } from "utils/privilegeManager";
import store from "redux/store";
import { showPlanNeededModal } from "../modal";
import { useModal } from "@slid/slid-ips";

export const useConfirmPrivilege = () => {
  const { showModal, closeModal } = useModal();
  const history = useHistory();
  const [isUserHasPrivilege, setIsUserHasPrivilege] = useState<boolean>(false);

  const confirmPrivilege = (privilege: SlidFeatures) => {
    const isFeatureAllowed = USER_PRIVILEGES.has(privilege);
    setIsUserHasPrivilege(isFeatureAllowed);
    return isFeatureAllowed;
  };

  const showInsufficientPrivilegeModal = (mustShowModal?: boolean) => {
    const userData = store.getState().slidGlobal.userData;
    const isMobileMembershipUser = userData?.payment === MembershipType.mobile_premium || userData?.payment === MembershipType.mobile_standard;

    if (mustShowModal) {
      return showPlanNeededModal({ showModal, closeModal, history });
    }
    if (!isUserHasPrivilege) {
      if (userData?.payment === MembershipType.break) {
        return showPlanNeededModal({ showModal, closeModal, history });
      } else if (isMobileMembershipUser) {
        return showPCMembershipNeededModal({ showModal, closeModal, history });
      } else {
        return showPlanUpgradeNeededModal({ showModal, closeModal, history });
      }
    }
  };

  return { confirmPrivilege, showInsufficientPrivilegeModal };
};
